import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      classificationPopin: _vm.mode == "popin"
    }
  }, [_c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Classification label",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.label,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "label", $$v);
      },
      expression: "baseModel.label"
    }
  })], 1), _vm.existingClassifications.length > 0 ? _c("div", {
    staticClass: "flex flex-column justify-start items-start mt-default"
  }, [_c("div", {
    staticClass: "flex items-baseline justify-start gap-2"
  }, [_c(VIcon, {
    class: ["fa cursor--pointer", _vm.isShowExisitingClassifications ? "fa-eye-slash" : "fa-eye"],
    attrs: {
      size: "16"
    },
    on: {
      click: function click($event) {
        return _vm.toggleShowClassifications();
      }
    }
  }), _c("span", {
    staticClass: "text-bold cursor--pointer",
    on: {
      click: function click($event) {
        return _vm.toggleShowClassifications();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.existingClassifications.length) + " existing classifications ")])], 1), _vm.isShowExisitingClassifications ? _c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.existingClassifications, function (item) {
    var _vm$manageExistingCla, _vm$manageExistingCla2, _vm$manageExistingCla3;
    return _c("li", {
      key: "existingClassification-".concat(item.id_classification),
      staticClass: "text-smaller py-1"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(_vm._s("".concat(item.label)))]), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-pen",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.startEditClassification(item.id_classification);
        }
      }
    }), _c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.deleteClassification(item.id_classification);
        }
      }
    })], 1)]), ((_vm$manageExistingCla = _vm.manageExistingClassification.error.delete) === null || _vm$manageExistingCla === void 0 ? void 0 : _vm$manageExistingCla.id_classification) == item.id_classification ? [_c("div", [((_vm$manageExistingCla2 = _vm.manageExistingClassification.error.delete) === null || _vm$manageExistingCla2 === void 0 ? void 0 : _vm$manageExistingCla2.code) === "appellation_attached" ? [_c("div", {
      staticClass: "flex items-baseline justify-start gap-2"
    }, [_c(VIcon, {
      class: ["fa cursor--pointer", _vm.manageExistingClassification.error.delete.isDetailsShown ? "fa-eye-slash" : "fa-eye"],
      attrs: {
        size: "16"
      },
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteAppellationAttached();
        }
      }
    }), _c("span", {
      staticClass: "errorLabel cursor--pointer",
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteAppellationAttached();
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.manageExistingClassification.error.delete.data.length) + " appellation(s) are attached to this classification. It can't be deleted ")])], 1), _vm.manageExistingClassification.error.delete.isDetailsShown ? _c("ul", {
      staticClass: "rm-margin pl-5"
    }, _vm._l(_vm.manageExistingClassification.error.delete.data, function (appellation) {
      return _c("li", {
        key: "existingClassification-".concat(item.id_classification, "-error-appellation-attached-").concat(appellation.id_appellation)
      }, [_vm._v(" " + _vm._s("".concat(appellation.appellation) + (appellation.classification ? " ".concat(appellation.classification, " ") : "") + "(".concat(appellation.region.name, ")")) + " ")]);
    }), 0) : _vm._e()] : _vm._e()], 2)] : _vm._e(), ((_vm$manageExistingCla3 = _vm.manageExistingClassification.model) === null || _vm$manageExistingCla3 === void 0 ? void 0 : _vm$manageExistingCla3.id_classification) === item.id_classification ? _c("div", {
      staticClass: "mt-2 pb-5 px-5 mb-3",
      staticStyle: {
        "border-left": "1px #dadada solid",
        "border-bottom": "1px #dadada solid"
      }
    }, [_c(VForm, {
      staticClass: "dfwa-form",
      model: {
        value: _vm.manageExistingClassification.form.valid,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingClassification.form, "valid", $$v);
        },
        expression: "manageExistingClassification.form.valid"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        label: "Classification label",
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.manageExistingClassification.model.label,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingClassification.model, "label", $$v);
        },
        expression: "manageExistingClassification.model.label"
      }
    })], 1), _c("div", {
      staticClass: "flex items-center mt-small"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          return _vm.closeEditExistingClassification();
        }
      }
    }, [_vm._v(" Cancel ")]), _c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      attrs: {
        rounded: true,
        disabled: !_vm.manageExistingClassification.form.valid
      },
      on: {
        click: function click($event) {
          return _vm.saveEditExistingClassification();
        }
      }
    }, [_vm._v(" Save ")])], 1)], 1) : _vm._e()], 2);
  }), 0) : _vm._e(), _vm._m(0)]) : _vm._e(), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Close")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.form.valid
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Save" : "Create") + " ")])], 1)], 1), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tip mt-small-2"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" Please be care to not create duplicate of existing classification. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };